export type FreeUserIntent = "shopper" | "reseller" | "both";

export const FREE_USER_INTENT_KEY = "dealhawk_free_user_intent";

const DEFAULT_INTENT: FreeUserIntent = "both";

function getBrowserStorage() {
  if (typeof window === "undefined") return null;
  return window.localStorage;
}

export function getFreeUserIntent(): FreeUserIntent {
  const storage = getBrowserStorage();
  const value = storage?.getItem(FREE_USER_INTENT_KEY);
  if (value === "shopper" || value === "reseller" || value === "both") {
    return value;
  }
  return DEFAULT_INTENT;
}

export function setFreeUserIntent(intent: FreeUserIntent) {
  const storage = getBrowserStorage();
  storage?.setItem(FREE_USER_INTENT_KEY, intent);
}

export function getFreeIntentCopy(intent: FreeUserIntent) {
  switch (intent) {
    case "shopper":
      return {
        label: "Saving money for myself",
        paywallTitle: "Start finding deals you would actually buy.",
        paywallSubtitle: "Keep every online feed free and add exact local store intelligence when you're ready.",
        welcomeTitle: "Find one deal worth buying today.",
        welcomeSubtitle: "Browse every online feed and view its full price history free.",
        upgradeHook: "Unlock exact local store markdowns, saved deals, and price alerts near your ZIP.",
      };
    case "reseller":
      return {
        label: "Flipping or resale",
        paywallTitle: "Start sourcing faster than the crowd.",
        paywallSubtitle: "Use the complete online catalog to validate pricing, then upgrade when you need local visibility and automation.",
        welcomeTitle: "Find one deal with obvious margin potential.",
        welcomeSubtitle: "Use every online feed to validate pricing and inspect its full price history free.",
        upgradeHook: "Unlock exact local store visibility, advanced insights, and alerts before the deal disappears.",
      };
    default:
      return {
        label: "Saving and sourcing",
        paywallTitle: "See if DealHawk fits the way you hunt deals.",
        paywallSubtitle: "Browse every online retailer free and upgrade for exact local deals and faster sourcing.",
        welcomeTitle: "Find your first real win.",
        welcomeSubtitle: "Browse every online feed and inspect its complete price history free.",
        upgradeHook: "Unlock exact local visibility, saved deals, and automation once you find something worth acting on.",
      };
  }
}

export function getIntentUpgradeHighlights(intent: FreeUserIntent): string[] {
  switch (intent) {
    case "shopper":
      return [
        "Reveal exact local store markdowns near your ZIP",
        "Save and organize online deals",
        "Turn promising finds into price alerts",
      ];
    case "reseller":
      return [
        "Check exact local store inventory and pricing gaps",
        "Use advanced confidence and prediction insights",
        "Track promising items with alerts instead of checking manually",
      ];
    default:
      return [
        "Unlock exact local store results and in-store pricing",
        "Save and organize online deals",
        "Automate follow-up with paid price alerts",
      ];
  }
}
